import ResponseAlerts from "../functions/ResponseAlerts";
import axios from "axios";

const BASE_URL = "notifications-service";

class NotificationsService {
	static async listTargets(query) {
		const searchParams = new URLSearchParams(query);
		try {
			return await axios.get(`${BASE_URL}/targets/paginated`, { params: searchParams });
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar notificações",
			});
			return error.response;
		}
	}

	static async listWebhooks(query) {
		const searchParams = new URLSearchParams(query);
		try {
			return await axios.get(`${BASE_URL}/webhooks/paginated`, { params: searchParams });
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar notificações",
			});
			return error.response;
		}
	}

	static async getWebhook(id) {
		try {
			return await axios.get(`${BASE_URL}/webhooks/${id}`);
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter webhook",
			});
			return error.response;
		}
	}

	static async listCategoriesTargets(query) {
		try {
			return await axios.get(`${BASE_URL}/categories-targets`);
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar relação de categorias de notificações e alvos",
			});
			return error.response;
		}
	}

	static async deleteTarget(id) {
		try {
			return await axios.delete(`${BASE_URL}/targets/${id}`);
		} catch (error) {
			console.log(error);
			return error.response;
		}
	}

	static async readTarget(id) {
		try {
			return await axios.put(`${BASE_URL}/targets/${id}/read`);
		} catch (error) {
			console.error(error);
			return error.response;
		}
	}

	static async readAllTargets() {
		try {
			return await axios.put(`${BASE_URL}/targets/read-all`);
		} catch (error) {
			console.error(error);
			return error.response;
		}
	}

	static async saveCategoriesTargets(payload) {
		try {
			const response = await axios.post(`${BASE_URL}/categories-targets/batch`, {
				...payload,
				method: 'POST',
			});
			if (response.data?.errors) throw new Error(`Campos inválidos`);
			ResponseAlerts({
				response: response,
				successMessage: "Configuração de notificações salva com sucesso",
			});
			return response;
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao salvar configuração",
			});
			return error.response;
		}
	}

	static async saveSmtpConfig(payload) {
		try {
			const response = await axios.put(`${BASE_URL}/organization-configs`, payload);
			if (response.data?.errors) throw new Error(`Campos inválidos`);
			ResponseAlerts({
				response: response,
				successMessage: "Configuração de SMTP salva com sucesso",
			});
			return response;
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao salvar configuração de SMTP",
			});
			return error.response;
		}
	}

	static async getSmtpConfig() {
		try {
			return await axios.get(`${BASE_URL}/organization-configs`);
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter configuração de SMTP",
			});
			return error.response;
		}
	}

	static async testSmtpConfig(payload) {
		try {
			const response = await axios.post(`${BASE_URL}/organization-configs/smtp-test`, payload);
			return response;
		} catch (error) {
			console.error(error);
			return error.response;
		}
	}

	static async createWebhook(payload) {
		try {
			const response = await axios.post(`${BASE_URL}/webhooks`, {
				...payload,
				method: 'POST',
			});
			if (response.data?.errors) throw new Error(`Campos inválidos`);
			ResponseAlerts({
				response: response,
				successMessage: "Webhook criado com sucesso",
			});
			return response;
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao criar o webhook",
			});
			return error.response;
		}
	}

	static async updateWebhook(id, payload) {
		try {
			const response = await axios.put(`${BASE_URL}/webhooks/${id}`, payload);
			if (response.data?.errors) throw new Error(`Campos inválidos`);
			ResponseAlerts({
				response: response,
				successMessage: "Webhook atualizado com sucesso",
			});
			return response;
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao atualizar o webhook",
			});
			return error.response;
		}
	}

	static async deleteWebhook(id) {
		try {
			const response = await axios.delete(`${BASE_URL}/webhooks/${id}`);
			if (response.data?.errors) throw new Error(`Campos inválidos`);
			ResponseAlerts({
				response: response,
				successMessage: "Webhook deletado com sucesso",
			});
			return response;
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao deletar o webhook",
			});
			return error.response;
		}
	}
}

export default NotificationsService;